export interface RouteContext {
  route: string;
  pathname: string;
  searchParams: Record<string, string>;
}

export function getCurrentRouteContext(): RouteContext {
  if (typeof window === 'undefined') {
    return {
      route: 'server',
      pathname: '',
      searchParams: {},
    };
  }

  const url = new URL(window.location.href);
  const searchParams: Record<string, string> = {};

  url.searchParams.forEach((value, key) => {
    searchParams[key] = value;
  });

  return {
    route: window.location.pathname,
    pathname: window.location.pathname,
    searchParams,
  };
}
